import { BaseQueryDTO } from './basequery-dto';

export class QueryExistingProposalForSupplierDTO extends BaseQueryDTO {
    PartNumber: string;
    SupplierCode: string;
    POUoMCode: string;
    SourceTypeId: number;
}
